import React, { useState, useEffect } from 'react';
import CorpInfo from './CorpInfo';
import CorpContact from './CorpContact';
import { fetchWithCorpId } from '../utils/api';

function CorpForm({ mode = 'create', initialData = {}, onSuccess, onCancel }) {
  const isEdit = mode === 'edit';
  const [corp, setCorp] = useState({
    name: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    status: '',
    startDate: '',
    updateDate: '',
    contacts: []
  });

  useEffect(() => {
    if (initialData) {
      setCorp(prev => ({
        ...prev,
        ...initialData,
        contacts: initialData.contacts || []
      }));
    }
  }, [initialData]);

  const [activeTab, setActiveTab] = useState('info');
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCorp(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = isEdit && corp.id
        ? `/corps/${corp.id}`
        : '/corps';

      await fetchWithCorpId(url, {
        method: isEdit ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(corp)
      });

      setMessage('✅ Saved successfully');
      setTimeout(() => {
        setMessage('');
        onSuccess();
      }, 1000);
    } catch (error) {
      setMessage('❌ Failed to save: ' + error.message);
    }
  };

  const tabStyle = (tab) => ({
    padding: '10px 20px',
    cursor: 'pointer',
    backgroundColor: activeTab === tab ? '#f0f8ff' : '#f9f9f9',
    borderBottom: activeTab === tab ? '2px solid #007bff' : '1px solid #ccc',
    fontWeight: activeTab === tab ? 'bold' : 'normal',
  });

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: '700px', marginTop: '20px' }}>
      <div style={{ display: 'flex', gap: '12px', borderBottom: '1px solid #ccc' }}>
        <div style={tabStyle('info')} onClick={() => setActiveTab('info')}>Info</div>
        <div style={tabStyle('contact')} onClick={() => setActiveTab('contact')}>Contact</div>
      </div>

      <div style={{ padding: '12px' }}>
        {activeTab === 'info' && (
          <CorpInfo corp={corp} onChange={handleChange} />
        )}
        {activeTab === 'contact' && (
          <CorpContact
            contacts={corp.contacts || []}
            setContacts={(updatedContacts) => setCorp(prev => ({ ...prev, contacts: updatedContacts }))}
          />
        )}
      </div>

      <div style={{ marginTop: '12px', display: 'flex', gap: '10px' }}>
        <button 
          type="submit" 
          style={{ 
            padding: '10px 20px',
            height: '40px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            minWidth: '120px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 0
          }}
        >
          Save
        </button>
        {onCancel && (
          <button 
            type="button" 
            onClick={onCancel} 
            style={{ 
              padding: '10px 20px',
              height: '40px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              minWidth: '120px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: 0
            }}
          >
            Cancel
          </button>
        )}
      </div>

      {message && (
        <div style={{ 
          marginTop: '12px', 
          padding: '8px', 
          borderRadius: '4px',
          backgroundColor: message.includes('✅') ? '#d4edda' : '#f8d7da',
          color: message.includes('✅') ? '#155724' : '#721c24'
        }}>
          {message}
        </div>
      )}
    </form>
  );
}

export default CorpForm;
